import { IconProps } from "./icon.type";

export function IcSidebarGroupManagement({ ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      {...props}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.7 18.5492C15.7 16.5335 14.8993 14.6005 13.474 13.1752C12.0487 11.7499 10.1156 10.9492 8.09998 10.9492M8.09998 10.9492C6.08434 10.9492 4.15126 11.7499 2.72598 13.1752C1.30071 14.6005 0.5 16.5335 0.5 18.5492M8.09998 10.9492C10.7233 10.9492 12.85 8.82255 12.85 6.19921C12.85 3.57586 10.7233 1.44922 8.09998 1.44922C5.47664 1.44922 3.34999 3.57586 3.34999 6.19921C3.34999 8.82255 5.47664 10.9492 8.09998 10.9492ZM19.5 17.5991C19.5 14.3976 17.6 11.4241 15.7 9.99915C16.3246 9.53058 16.824 8.91529 17.154 8.20771C17.4841 7.50014 17.6347 6.7221 17.5924 5.94247C17.5502 5.16284 17.3164 4.40565 16.9117 3.73791C16.5071 3.07017 15.9441 2.51247 15.2725 2.11417"
        stroke="#6D7E91"
        stroke-width="1.14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
